import { render } from "./OpenAIAPIBotSettings.vue?vue&type=template&id=458805c5"
import script from "./OpenAIAPIBotSettings.vue?vue&type=script&lang=js"
export * from "./OpenAIAPIBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__